<template>
	<b-modal
		ref="asign-cintillo-modal"
		size="lg"
		title="AGREGAR CINTILLOS"
		hide-footer
		@hidden="$emit('close')"
		scrollable
	>
		<b-nav tabs>
			<b-nav-item
				v-for="cintilloNav in cintilloNavs"
				:key="`cintilloNav-${cintilloNav.id}`"
				@click="changeNav(cintilloNav.id)"
				:active="cintilloNav.id === nav"
			>
				{{ cintilloNav.name }}
			</b-nav-item>
		</b-nav>
		<b-overlay :show="isLoading">
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<div class="d-flex">
							<b-input-group id="cintillo-ala-input-group">
								<b-form-input
									v-model="search"
									class="d-inline-block"
									placeholder="Por código"
									@keyup.enter="handleInputSearch"
									debounce="500"
								/>
								<b-input-group-append>
									<b-button variant="outline-primary" @click="handleInputSearch()">
										<feather-icon class="cursor-pointer" icon="SearchIcon" />
									</b-button>
								</b-input-group-append>
							</b-input-group>
						</div>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in filteredFields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="chicks.length > 0">
						<b-tr v-for="(chick, index) in chicks" :key="index">
							<b-td class="text-center">
								<b-badge>
									{{ chick.correlative }}
								</b-badge>
							</b-td>
							<b-td class="text-center" v-if="nav === 1">
								<CombChickenlegsCintillos
									:postura="{
										id: chick.cintillo_pata_brother.id,
										chickenleg_wich_leg: chick.cintillo_pata_brother.chickenleg_wich_leg,
										chickenleg_qty_cintillos: chick.cintillo_pata_brother.qty_cintillos,
										cintillo_color: chick.cintillo_pata_brother.hex_1,
										cintillo_description: chick.cintillo_pata_brother.description_1,
										second_color_color: chick.cintillo_pata_brother.hex_2,
										second_color_description: chick.cintillo_pata_brother.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="1"
								/>
							</b-td>
							<b-td class="text-center" v-if="nav === 1">
								<CombChickenlegsCintillos
									:postura="{
										id: chick.cintillo_pata_brother.id,
										chickenleg_wich_leg: chick.cintillo_pata_brother.chickenleg_wich_leg,
										chickenleg_qty_cintillos: chick.cintillo_pata_brother.qty_cintillos,
										cintillo_color: chick.cintillo_pata_brother.hex_1,
										cintillo_description: chick.cintillo_pata_brother.description_1,
										second_color_color: chick.cintillo_pata_brother.hex_2,
										second_color_description: chick.cintillo_pata_brother.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="2"
								/>
							</b-td>
							<b-td class="text-center">
								<b-button
									variant="outline-primary"
									size="sm"
									@click="nav === 1 ? assignToChicks(chick) : openFreeChickCintillosModal(chick)"
								>
									<feather-icon icon="PlusIcon" size="16" />
								</b-button>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="chicks.length === 0">
						<b-td :colspan="filteredFields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
		<FreeChickCintillosModal
			v-if="showFreeChickCintillosModal"
			@close="showFreeChickCintillosModal = false"
			:chick="selectedChick"
			@refresh="handleRefreshFreeChickCintillos"
		/>
	</b-modal>
</template>

<script>
import chicksService from "@/services/encaste/chicks.service"
import CombChickenlegsCintillos from "@/views/amg/encaste/lotes/components/CombChickenlegsCintillos.vue"
import FreeChickCintillosModal from "@/views/amg/encaste/corrales/components/FreeChickCintillosModal.vue"
export default {
	components: { CombChickenlegsCintillos, FreeChickCintillosModal },
	props: {
		corralId: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		showFreeChickCintillosModal: false,
		cintilloNavs: [
			{ id: 1, name: "PREDEFINIDO" },
			{ id: 2, name: "LIBRE" },
		],
		selectedChick: null,
		search: "",
		isLoading: false,
		fields: [
			{ key: "correlative", label: "Pollo", class: "text-center", visible: true },
			{ key: "left", label: "PATA IZQUIERDA", class: "text-center", visible: true },
			{ key: "right", label: "PATA DERECHA", class: "text-center", visible: true },
			{ key: "select", label: "ACCIÓN", class: "text-center", visible: true },
		],
		perPageOptions: [10, 25, 50],
		pagination: {
			total: 0,
			curPage: 1,
			perPage: 25,
			from: 0,
			to: 0,
		},
		chicks: [],
		nav: 1,
	}),
	computed: {
		filteredFields() {
			this.changeFieldByKey("left", this.nav === 1)
			this.changeFieldByKey("right", this.nav === 1)
			return this.fields.filter((field) => field.visible)
		},
	},
	methods: {
		handleRefreshFreeChickCintillos() {
			this.nav = 1
			this.search = ""
			this.refresh()
			this.$emit("refresh")
		},
		async assignToChicks(chick) {
			try {
				const { isConfirmed } = await this.showConfirmSwal({
					title: "Asignar Cintillo",
					text: `¿Estás seguro de que deseas asignar este cintillo al pollo ${chick.correlative}?`,
				})
				if (!isConfirmed) return
				await chicksService.assignToChicks({
					chick_id: chick.id,
					cintillo_pata_id: chick.cintillo_pata_brother.id,
				})
				this.$emit("refresh")
				this.nav = 1
				this.search = ""
				this.refresh()
				this.showSuccessToast("Cintillo asignado correctamente")
			} catch (error) {
				console.error("Error assigning cintillo to chick:", error)
			}
		},
		changeFieldByKey(key, value) {
			const field = this.fields.find((f) => f.key === key)
			if (field) {
				field.visible = value
			}
		},
		openFreeChickCintillosModal(chick) {
			this.showFreeChickCintillosModal = true
			this.selectedChick = chick
		},
		changeNav(nav) {
			this.nav = nav
			this.getRows()
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				const { data } = await chicksService.getChicksWithoutCintillos({
					has_brothers: this.nav === 1 ? 1 : 0,
					page,
					per_page: this.pagination.perPage,
					corral_id: this.corralId,
					search: this.search,
				})
				this.chicks = data.data
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.error("Error fetching average weights report chicks:", error)
			} finally {
				this.isLoading = false
			}
		},
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getRows(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getRows()
		},
	},
	async mounted() {
		await this.getRows()
		this.$refs["asign-cintillo-modal"].toggle()
	},
}
</script>
